export default {"src":"/_next/static/media/care-team-at-work-emotional.mono.29593c79.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};